import styles from "../../styles/DocentesStyles/PantallaDocentes.module.css";

const TableHeader = () => {
  return (
    <div className={styles.tableHeaderContainer}>
      <div className={styles.tableTitle}>
        <div className={styles.titleIcon}>
          <span role="img" aria-label="Asesores">👨‍🏫</span>
        </div>
        <h2 className={styles.tableTitleText}>Asesores</h2>
      </div>
      {/* Paginación superior eliminada */}
    </div>
  );
};

export default TableHeader;
